import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPromoCode, IPromoCodeInitialState } from "./promocodeModel";
import {
  createPromoCode,
  deletePromoCode,
  findAllActivePromoCode,
  getAllPromoCodes,
  getPromoCodeById,
  promocodeActiveInactive,
  updatePromoCode,
} from "./services/promocode.services";

const initialState: IPromoCodeInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  PromoCodeList: [],
  PromoCodeID: null,
  PromoCodeDetail: {
    Type: "Auto",
    ID: null,
    PromoCode: "",
    FromDate: "",
    ToDate: "",
    DiscountType: "",
    Value: 0,
    MaxDiscount: 0,
    ApplyOn: "",
    IsActive: 1,
  },
};

const promocodeSlice = createSlice({
  name: "promocode",
  initialState,
  reducers: {
    clearPromoCodeDetails: (state) => {
      state.PromoCodeDetail = initialState.PromoCodeDetail;
    },
    setPromoCodeID: (state, action) => {
      state.PromoCodeID = action.payload;
    },
    clearPromoCodeID: (state) => {
      state.PromoCodeID = initialState.PromoCodeID;
    },
  },
  extraReducers: (builder) => {
    /* For getAll Cities */
    builder.addCase(getAllPromoCodes.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllPromoCodes.fulfilled,
      (state, action: PayloadAction<IPromoCode[]>) => {
        state.loading = false;
        state.PromoCodeList = action.payload || [];
      }
    );
    builder.addCase(getAllPromoCodes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PromoCodeList = [];
    });

    /* For getPromoCodeBy ID */
    builder.addCase(getPromoCodeById.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getPromoCodeById.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.PromoCodeDetail = action.payload;
    });
    builder.addCase(getPromoCodeById.rejected, (state, action) => {
      state.formLoading = false;
      state.PromoCodeDetail = initialState.PromoCodeDetail;
      state.error = action.error.message || "Something went wrong";
    });

    /* For create PromoCode */
    builder.addCase(createPromoCode.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createPromoCode.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createPromoCode.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For Update PromoCode */
    builder.addCase(updatePromoCode.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updatePromoCode.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updatePromoCode.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For Delete Cities */
    builder.addCase(deletePromoCode.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deletePromoCode.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deletePromoCode.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For PromoCodeActiveInactive */
    builder.addCase(promocodeActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(promocodeActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(promocodeActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For FindAllActiveStates */
    builder.addCase(findAllActivePromoCode.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllActivePromoCode.fulfilled,
      (state, action: PayloadAction<IPromoCode[]>) => {
        state.loading = false;
        state.PromoCodeList = action.payload || [];
      }
    );
    builder.addCase(findAllActivePromoCode.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PromoCodeList = [];
    });
  },
});

export const { clearPromoCodeID, clearPromoCodeDetails, setPromoCodeID } =
  promocodeSlice.actions;
export default promocodeSlice.reducer;
